<script>
import Modal from './modal';
import ForkissIcon from './forkiss-icon';
import mixin from './mixins_api';

const SEND_CODE_TIME = 60;
export default {
    mixins: [mixin],
    components: {
        Modal,
        ForkissIcon
    },
    methods: {
        showHints() {
            this.showHintsModal = true;
        },
        handleLogin() {
            if (!this.telephone) {
                this.$root.$emit('showToast', '请输入手机号码');
                return;
            }
            if (!this.code) {
                this.$root.$emit('showToast', '请输入验证码');
                return;
            }
            // if (this.telephone !== '12345678910') {
            //     this.$root.$emit('showToast', '请输入正确的手机号码');
            //     return;
            // }
            // if (this.code !== '666666') {
            //     this.$root.$emit('showToast', '验证码错误，请重新输入');

            // }

            this.postLogin({
                mobile: this.telephone.trim(),
                smscode: this.code.trim(),
                token: this.getQueryString('token')
            }).then(res => {
                console.log('postLogin =>', res);
                this.$router.push({
                    name: 'home'
                });
            })
        },
        handleSendCode() {
            if (!this.telephone) {
                this.$root.$emit('showToast', '请输入正确的手机号码');
                return;
            }
            if (this.isSendCode) {
                return;
            }
            this.isSendCode = true;
            --this.time;
            this.message = `${this.time}s后重新发送`;

            this.intervalId = setInterval(() => {
                --this.time;
                if (this.time <= 0) {
                    clearInterval(this.intervalId);
                    this.isSendCode = false;
                    this.message = '发送验证码';
                    this.time = SEND_CODE_TIME;
                } else {
                    this.message = `${this.time}s后重新发送`;
                }
            }, 1000);

            this.postSms({
                mobile: this.telephone.trim()
            }).then(res => {
                console.log('postSms =>', res);
            });
        }
    },
    mounted() {
        // 解决安卓软键盘弹起压缩页面高度的问题
        this.$refs.loginContainer.style.height = window.innerHeight + 'px';
    },
    data() {
        return {
            showHintsModal: false,
            intervalId: null,
            telephone: '',
            code: '',
            time: SEND_CODE_TIME,
            message: '发送验证码',
            isSendCode: false
        };
    }
};
</script>

<template lang="pug">
.login-container(ref="loginContainer")
    .login-wrapper
        .title 登录[仅限forkiss用户使用此小程序]
        .input-box
            input.forkiss-input(placeholder="请输入手机号码", v-model="telephone")
        .input-box
            input.forkiss-input(placeholder="请输入验证码", v-model="code")
            a.sendcode-btn(@click="handleSendCode", :class="{disabed: isSendCode}") {{message}}
        button.login-btn(@click="handleLogin", data-touch="true") 登录
    a.hints-box(@click="showHints", data-touch="true")
        ForkissIcon(icon="forkiss-icon-question-white") FORKISS账号说明
    Modal(:show="showHintsModal", okText="我知道了", @ok="showHintsModal = false")
        span(slot="header") 提醒
        span FORKISS账号需要在门店进行注册，请联系您的导师或到店咨询
</template>

<style lang="less" scoped>
.login-container {
    position: relative;
    height: 100%;
    background: url(../assets/login-bg.png);
    background-size: cover;
    background-position: center;

    .login-wrapper {
        padding: 2.24rem .7rem .58rem;
        .title {
            color: #FFF;
            font-size: .52rem;
            font-weight: 600;
        }

        .input-box {
            position: relative;

            & + .input-box {
                margin-top: .3rem;
            }
        }

        .forkiss-input {
            width: 100%;
            background: transparent;
            border: none;
            border-radius: 0;
            outline: none;
            padding: .3rem 0;
            border-bottom: 1px solid #EEE;
            color: #FFF;
            font-size: .32rem;

            &::placeholder {
                color: rgba(255, 255, 255, .4);
            }
        }
        .sendcode-btn {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            color: #FFF;

            &.disabed {
                color: rgba(255, 255, 255, .4);
            }
        }
        .login-btn {
            width: 100%;
            height: .96rem;
            margin-top: .96rem;
            border: none;
            border-radius: .5rem;
            line-height: .96rem;
            color: #FFF;
            background: #c3a07b;
            font-size: .36rem;
            outline: none;
        }
    }


    .hints-box {
        position: absolute;
        left: 50%;
        bottom: .3rem;
        transform: translateX(-50%);
        color: #FFF;
        font-size: .28rem;

        * {
            pointer-events: none;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue